import { useEffect, useState } from 'react';

export const useCssCustomProperty = (
  customProperty: string,
  element: HTMLElement = document.documentElement,
): string => {
  const [value, setValue] = useState('');

  useEffect(() => {
    const customPropertyWithPrefix = customProperty.startsWith('--')
      ? customProperty
      : `--${customProperty}`;

    const cssValue = getComputedStyle(element)
      .getPropertyValue(customPropertyWithPrefix)
      .trim();

    setValue(cssValue);

    // ToDo: Set up a MutationObserver to watch for style changes.
    // This would make the hook reactive to runtime CSS changes
  }, [customProperty, element]);

  return value;
};
